import { styled, Box, Tab, Typography, Tabs, makeStyles, createStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CHIP_BACKGROUND,
  DARK_CONTAINER_FIELDS_ON_CARD,
  DARK_FIELDS_ON_CARD_MENU,
  DARK_ICON,
  DARK_TAB_BACKGROUND,
  DARK_TAB_BORDER,
  ERROR_CHIP_ICON,
  LIGHT_CHIP_BACKGROUND,
  LIGHT_CONTAINER_FIELDS_ON_CARD,
  LIGHT_MENUITEM_BACKGROUND,
  LIGHT_TAB_BACKGROUND,
  PLAIN_ICON,
  PRIMARY_TAB_BORDER,
} = COLORS;

export const MainCont = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 30,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    height: '100%',
    gap: 0,
  },
  height: '85vh',
}));

export const Content = styled('div')(({ theme }) => ({
  margin: '20px 20px 0',
  padding: '20px 20px 0',
  width: '100%',
  height: '100%',
  borderRadius: 8,
  background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
  flex: 1,
}));

export const TabStyle = styled(Tab)(({ theme }) => ({
  background: theme.palette.type === 'dark' ? `${DARK_FIELDS_ON_CARD_MENU} !important` : LIGHT_MENUITEM_BACKGROUND,
  width: '100%',
  marginBottom: 10,
  borderRadius: 8,
  border: `1px solid ${DARK_TAB_BORDER}`,
  textAlign: 'start',
  '& .MuiTab-wrapper': {
    flexDirection: 'unset',
    justifyContent: 'unset',
  },
  '&.Mui-selected': {
    borderColor: PRIMARY_TAB_BORDER,
    background: theme.palette.type === 'dark' ? DARK_TAB_BACKGROUND : LIGHT_TAB_BACKGROUND,
  },

  '& p': {
    fontSize: 14,
  },
}));

export const CustomTabs = styled(Tabs)(({ theme }) => ({
  minWidth: 240,
  overflow: 'auto',
  maxHeight: 'calc(100vh - 200px)',

  '& .MuiTabs-indicator': {
    display: 'none',
  },

  [theme.breakpoints.down('md')]: {
    '& .MuiTabs-flexContainer': {
      flexDirection: 'unset',
      gap: 20,
      minWidth: 'unset',
    },
  },
  [theme.breakpoints.down('xs')]: {
    '& .MuiTabs-flexContainer': {
      gap: 20,
    },
  },
}));

export const ItemContainer = styled('div')(({ theme }) => ({
  overflow: 'auto',
  flex: 1,
  [theme.breakpoints.up(700)]: {
    paddingRight: 20,
    marginBottom: 20,
  },
}));

export const TabHeaderCont = styled('div')(() => ({
  display: 'flex',
  width: '100%',
}));

export const HeaderTitle = styled(Typography)(() => ({
  flex: 1,
  textTransform: 'capitalize',
}));

export const SkillLabelCont = styled(Typography)(() => ({
  marginLeft: 'auto',
  textTransform: 'lowercase',
}));

export const Container = styled('div')(() => ({
  margin: '20px 20px 0',
}));

export const ChipsContainer = styled('div')(() => ({
  display: 'flex',
  gap: 15,
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
}));

export const Chips = styled('div')(({ theme }) => ({
  display: 'flex',
  background: theme.palette.type === 'dark' ? DARK_CHIP_BACKGROUND : LIGHT_CHIP_BACKGROUND,
  height: 30,
  minWidth: 106,
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 13px',
  borderRadius: 5,

  '& .MuiSvgIcon-root': {
    marginLeft: 15,
    width: 16,
  },

  '& path': {
    fill: ERROR_CHIP_ICON,
  },
}));

// New Styles
export const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      '& .MuiSelect-icon': {
        color: (theme.palette.type === 'dark' ? PLAIN_ICON : DARK_ICON) + '!important', // Change this to your desired color,
      },
    },
    option: {
      '&:hover': {
        backgroundColor: theme.palette.type === 'dark' ? '' : LIGHT_MENUITEM_BACKGROUND,
      },
      '&[data-focus="true"]': {
        backgroundColor: theme.palette.type === 'dark' ? '' : LIGHT_MENUITEM_BACKGROUND,
      },
    },
  }),
);
